<template>
  <div
      class="sidebar"
      :class="{'mobile-open': mobileOpen}"
  >
    <div class="sidebar-header">
      <h2><i class="fas fa-dragon"></i> <a href="/" style="color:white;">首页</a></h2>
    </div>
    <div class="menu-items">
      <div
          class="menu-item"
          v-for="(item, index) in menuItems"
          :key="index"
          :class="{'active': activeMenu === item.key}"
          @click="$emit('switch-menu', item.key)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'GameSidebar',
  props: {
    activeMenu: {
      type: String,
      required: true,
      default: 'item'
    },
    mobileOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      // menuItems: [
      //   { key: 'item', label: '物品查询', icon: 'fas fa-cube' },
      //   { key: 'monster', label: '怪物查询', icon: 'fas fa-dragon' },
      //   { key: 'map', label: '地图查询', icon: 'fas fa-map-marked-alt' },
      //   { key: 'npc', label: 'NPC查询', icon: 'fas fa-user-friends' },
      //   { key: 'strategy', label: '版本攻略', icon: 'fas fa-book' },
      //   { key: 'repair', label: '修复记录', icon: 'fas fa-tools' }
      // ],
      menuItems: [
        { key: 'item', label: '物品查询'},
        { key: 'monster', label: '怪物查询'},
        { key: 'map', label: '地图查询'},
        { key: 'npc', label: 'NPC查询'},
        { key: 'strategy', label: '版本攻略'},
        { key: 'repair', label: '修复记录'}
      ],
    };
  }
};
</script>

<style scoped>
.sidebar {
  width: 200px;
  color: white;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow-y: auto;
}

.sidebar-header {
  height:60px;
  line-height: 60px;
  text-align: center;
  background:#222b45;
}

.sidebar-header h2 {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.menu-items {
  display: flex;
  flex-direction: column;
  flex: 1;
  color:black;
}

.menu-item {
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.3s;
  border-left: 4px solid transparent;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e6e6e6;
}

.menu-item:hover {
  background-color: #ebf5ff;
}

.menu-item.active {
  background-color: #409eff;
}

.menu-item i {
  width: 20px;
  text-align: center;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .sidebar {
    position: absolute;
    left: -100%;
    transition: left 0.3s;
    height: 40%;
    width: 200px;
  }

  .sidebar.mobile-open {
    left: 0;
    background:#ffffff;
    width:25%;
    text-align:center;
  }

  .sidebar-header {
    display: block;
  }

  .menu-items {
    flex-direction: column;
  }

  .menu-item {
    flex: none;
    justify-content: flex-start;
    border-left: 4px solid transparent;
    border-bottom: none;
    text-align: left;
  }

  .menu-item.active {
    border-left-color: #ffc107;
    border-bottom: none;
  }
}

@media (max-width: 576px) {
  .menu-item {
    padding: 10px 5px;
  }

  .menu-item span {
    font-size: 11px;
  }
}
</style>
